<p-floatlabel>
    <input pInputText [id]="htmlId()" [(ngModel)]="value" (ngModelChange)="onChange($event)" (blur)="onTouched()"
        autocomplete="off" [class]="classInputText()" [type]="type()" #customInputText />
    <label [for]="htmlId()"> {{label()}}</label>
</p-floatlabel>